"use strict";

var _interopRequireDefault = require("E:/zkdn_workspace/zhijiao/bjzyjy-mhwz/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.worksSubmit = exports.worksSet = exports.unitTree = exports.unitRemove = exports.unitList = exports.unitAdd = exports.tecLsit = exports.submitAuditMax = exports.stageTecDel = exports.stageTecAdd = exports.stageList = exports.stageGroupList = exports.stageGroupDel = exports.stageGroupAdd = exports.stageDel = exports.stageAllList = exports.setMaxWorks = exports.scoreSet = exports.scoreSave = exports.scoreRuleSave = exports.resetPass = exports.removeAdmin = exports.projectList = exports.projectEdit = exports.projectDel = exports.projectAdd = exports.payForAdmin = exports.noStageTec = exports.noStageGroup = exports.matchGroupListAll = exports.insertAllSchoolAllMatchSchool = exports.groupList = exports.groupEdit = exports.groupDel = exports.groupAdd = exports.getStageEditInfo = exports.getScoreRule = exports.getSchoolList = exports.getObjectAdminList = exports.getMatchMaterialUrl = exports.findObjectAdminList = exports.exportJiangsuTableSecond = exports.delAdmin = exports.changeStage = exports.backView = exports.addObjectAdmin = exports.addAdminList = void 0;
var _api = _interopRequireDefault(require("_l/api.request"));
var _qs = _interopRequireDefault(require("qs"));
/**
 * 描述 获取项目列表
 * @author kkdy
 * @date 2021-11-23
 * @param {any} data
 * @returns {any}
 */
var projectList = exports.projectList = function projectList(data) {
  return _api.default.request({
    url: '/match/matchList',
    method: 'post',
    data: data
  });
};
/**
 * 描述 新增项目
 * @author kkdy
 * @date 2021-11-26
 * @param {any} data
 * @returns {any}
 */
var projectAdd = exports.projectAdd = function projectAdd(data) {
  return _api.default.request({
    url: '/match/insertMatch',
    method: 'post',
    data: data
  });
};
/**
 * 描述 删除项目
 * @author kkdy
 * @date 2021-11-26
 * @param {any} data
 * @returns {any}
 */
var projectDel = exports.projectDel = function projectDel(data) {
  return _api.default.request({
    url: '/match/deleteById',
    method: 'post',
    data: data
  });
};
/**
 * 描述 编辑项目
 * @author kkdy
 * @date 2021-11-26
 * @param {any} data
 * @returns {any}
 */
var projectEdit = exports.projectEdit = function projectEdit(data) {
  return _api.default.request({
    url: '/match/updateMatch',
    method: 'post',
    data: data
  });
};
/**
 * 描述 获取该项目组别
 * @author kkdy
 * @date 2021-11-29
 * @param {any} data
 * @returns {any}
 */
var groupList = exports.groupList = function groupList(data) {
  return _api.default.request({
    url: '/matchGroup/matchGroupList',
    method: 'post',
    data: data
  });
};
/**
 * 获取全部
 * @author kkdy
 * @date 2021-11-29
 * @param {any} data
 * @returns {any}
 */
var matchGroupListAll = exports.matchGroupListAll = function matchGroupListAll(data) {
  return _api.default.request({
    url: '/matchGroup/matchGroupListAll',
    method: 'post',
    data: data
  });
};
/**
 * 描述 新增项目组别
 * @author kkdy
 * @date 2021-11-29
 * @param {any} data
 * @returns {any}
 */
var groupAdd = exports.groupAdd = function groupAdd(data) {
  return _api.default.request({
    url: '/matchGroup/insertMatchGroup',
    method: 'post',
    data: data
  });
};
/**
 * 描述 删除项目组别
 * @author kkdy
 * @date 2021-11-29
 * @param {any} data
 * @returns {any}
 */
var groupDel = exports.groupDel = function groupDel(data) {
  return _api.default.request({
    url: '/matchGroup/deleteById',
    method: 'post',
    data: data
  });
};
/**
 * 描述 编辑项目组别
 * @author kkdy
 * @date 2021-11-29
 * @param {any} data
 * @returns {any}
 */
var groupEdit = exports.groupEdit = function groupEdit(data) {
  return _api.default.request({
    url: '/matchGroup/updateMatchGroup',
    method: 'post',
    data: data
  });
};
/**
 * 描述 获取项目参赛单位
 * @author kkdy
 * @date 2021-11-29
 * @param {any} data
 * @returns {any}
 */
var unitList = exports.unitList = function unitList(data) {
  return _api.default.request({
    url: '/matchSchool/listPage',
    method: 'post',
    data: data
  });
};
/**
 * 描述 新增项目单位
 * @author kkdy
 * @date 2021-11-29
 * @param {any} data
 * @returns {any}
 */
var unitAdd = exports.unitAdd = function unitAdd(data) {
  return _api.default.request({
    url: '/matchSchool/saveBatch',
    method: 'post',
    data: data
  });
};
/**
 * 描述 移出项目单位
 * @author kkdy
 * @date 2021-11-30
 * @param {any} data
 * @returns {any}
 */
var unitRemove = exports.unitRemove = function unitRemove(data) {
  return _api.default.request({
    url: '/matchSchool/removeOne',
    method: 'post',
    data: data
  });
};
/**
 * 下载申报材料
 * @author kkdy
 * @date 2021-11-30
 * @param {any} data
 * @returns {any}
 */
var getMatchMaterialUrl = exports.getMatchMaterialUrl = function getMatchMaterialUrl(data) {
  return _api.default.request({
    url: '/matchMaterial/getMatchMaterialUrl',
    method: 'post',
    data: _qs.default.stringify(data)
  });
};
/**
 * 描述  设置最大作品数
 * @author kkdy
 * @date 2021-11-30
 * @param {any} data
 * @returns {any}
 */
var setMaxWorks = exports.setMaxWorks = function setMaxWorks(data) {
  return _api.default.request({
    url: '/matchSchool/editMaxWork',
    method: 'post',
    data: data
  });
};
/**
 * 描述  设置最大审核数
 * @author kkdy
 * @date 2021-11-30
 * @param {any} data
 * @returns {any}
 */
var submitAuditMax = exports.submitAuditMax = function submitAuditMax(data) {
  return _api.default.request({
    url: '/matchSchool/editAuditNumber',
    method: 'post',
    data: data
  });
};
/**
 * 描述 获取项目单位树结构
 * @author kkdy
 * @date 2021-11-30
 * @param {any} data
 * @returns {any}
 */
var unitTree = exports.unitTree = function unitTree(data) {
  return _api.default.request({
    url: '/matchSchool/getMechanismTreeList',
    method: 'post',
    data: _qs.default.stringify(data)
  });
};
/**
 * 描述 获取该项目下的所有阶段
 * @author kkdy
 * @date 2021-11-29
 * @param {any} data
 * @returns {any}
 */
var stageList = exports.stageList = function stageList(data) {
  return _api.default.request({
    url: '/matchStage/getMatchStageListAll',
    method: 'post',
    data: _qs.default.stringify(data)
  });
};
/**
 * 描述 获取所有项目阶段
 * @author kkdy
 * @date 2021-11-29
 * @param {any} data
 * @returns {any}
 */
var stageAllList = exports.stageAllList = function stageAllList(data) {
  return _api.default.request({
    url: '/matchStage/getMatchStageListForPage',
    method: 'post',
    data: data
  });
};
/**
 * 描述 根据Id获取项目阶段
 * @author kkdy
 * @date 2022-01-05
 * @param {any} data
 * @returns {any}
 */
var getStageEditInfo = exports.getStageEditInfo = function getStageEditInfo(data) {
  return _api.default.request({
    url: '/matchStage/getMatchStage',
    method: 'post',
    data: _qs.default.stringify(data)
  });
};
/**
 * 描述 新增/编辑项目阶段
 * @author kkdy
 * @date 2021-11-29
 * @param {any} data
 * @returns {any}
 */
var changeStage = exports.changeStage = function changeStage(data) {
  return _api.default.request({
    url: '/matchStage/insertOrUpdateStage',
    method: 'post',
    data: data
  });
};
/**
 * 描述 删除项目阶段
 * @author kkdy
 * @date 2021-11-29
 * @param {any} data
 * @returns {any}
 */
var stageDel = exports.stageDel = function stageDel(data) {
  return _api.default.request({
    url: '/matchStage/deleteStage',
    method: 'post',
    data: data
  });
};
/**
 * 描述 项目阶段下的组别列表
 * @author kkdy
 * @date 2021-11-29
 * @param {any} data
 * @returns {any}
 */
var stageGroupList = exports.stageGroupList = function stageGroupList(data) {
  return _api.default.request({
    url: '/matchStageGroup/getStageGroupList',
    method: 'post',
    data: data
  });
};
/**
 * 描述 新增项目阶段下的组别
 * @author kkdy
 * @date 2021-11-29
 * @param {any} data
 * @returns {any}
 */
var stageGroupAdd = exports.stageGroupAdd = function stageGroupAdd(data) {
  return _api.default.request({
    url: '/matchStageGroup/insertStageGroup',
    method: 'post',
    data: data
  });
};
/**
 * 描述 获取未分配阶段的组别
 * @author kkdy
 * @date 2021-11-29
 * @param {any} data
 * @returns {any}
 */
var noStageGroup = exports.noStageGroup = function noStageGroup(data) {
  return _api.default.request({
    url: '/matchStageGroup/getNoAssignGroupList',
    method: 'post',
    data: _qs.default.stringify(data)
  });
};
/**
 * 描述 删除阶段下的组别
 * @author kkdy
 * @date 2021-11-30
 * @param {any} data
 * @returns {any}
 */
var stageGroupDel = exports.stageGroupDel = function stageGroupDel(data) {
  return _api.default.request({
    url: '/matchStageGroup/delStageGroup',
    method: 'post',
    data: data
  });
};
/**
 * 描述 参赛作品设置
 * @author kkdy
 * @date 2021-11-29
 * @param {any} data
 * @returns {any}
 */
var worksSet = exports.worksSet = function worksSet(data) {
  return _api.default.request({
    url: '/matchScoreItemRule/getMatchWorksRule',
    method: 'post',
    data: _qs.default.stringify(data)
  });
};
/**
 * 描述 提交作品项
 * @author kkdy
 * @date 2021-11-29
 * @param {any} data
 * @returns {any}
 */
var worksSubmit = exports.worksSubmit = function worksSubmit(data) {
  return _api.default.request({
    url: '/matchScoreItemRule/setMatchWorksRule',
    method: 'post',
    data: data
  });
};
/**
 * 描述 评分项设置
 * @author kkdy
 * @date 2021-11-30
 * @param {any} data
 * @returns {any}
 */
var scoreSet = exports.scoreSet = function scoreSet(data) {
  return _api.default.request({
    url: '/matchScoreItemRule/getMatchScoringItemRule',
    method: 'post',
    data: _qs.default.stringify(data)
  });
};
/**
 * 描述 保存评分项
 * @author kkdy
 * @date 2021-11-30
 * @param {any} data
 * @returns {any}
 */
var scoreSave = exports.scoreSave = function scoreSave(data) {
  return _api.default.request({
    url: '/matchScoreItemRule/setMatchScoringItemRule',
    method: 'post',
    data: data
  });
};
/**
 * 描述 获取专家评分规则详情
 * @author kkdy
 * @date 2021-11-30
 * @param {any} data
 * @returns {any}
 */
var getScoreRule = exports.getScoreRule = function getScoreRule(data) {
  return _api.default.request({
    url: '/ MatchExpertAssignRules/getRules',
    method: 'post',
    data: _qs.default.stringify(data)
  });
};
/**
 * 描述 保存专家评分规则详情
 * @author kkdy
 * @date 2021-11-30
 * @param {any} data
 * @returns {any}
 */
var scoreRuleSave = exports.scoreRuleSave = function scoreRuleSave(data) {
  return _api.default.request({
    url: '/ MatchExpertAssignRules/insertOrUpdateAssignRules',
    method: 'post',
    data: data
  });
};
/**
 * 描述 获取阶段下的专家列表
 * @author kkdy
 * @date 2021-11-30
 * @param {any} data
 * @returns {any}
 */
var tecLsit = exports.tecLsit = function tecLsit(data) {
  return _api.default.request({
    url: '/matchStageExpert/getMatchStageExpertList',
    method: 'post',
    data: data
  });
};
/**
 * 描述 获取阶段下未分配专家列表
 * @author kkdy
 * @date 2021-11-30
 * @param {any} data
 * @returns {any}
 */
var noStageTec = exports.noStageTec = function noStageTec(data) {
  return _api.default.request({
    url: '/matchStageExpert/getStageNoAssignExpertList',
    method: 'post',
    data: data
  });
};
/**
 * 描述 新增阶段下的专家
 * @author kkdy
 * @date 2021-11-30
 * @param {any} data
 * @returns {any}
 */
var stageTecAdd = exports.stageTecAdd = function stageTecAdd(data) {
  return _api.default.request({
    url: '/matchStageExpert/insertStageExpert',
    method: 'post',
    data: data
  });
};
/**
 * 描述 删除阶段下的专家
 * @author kkdy
 * @date 2021-11-30
 * @param {any} data
 * @returns {any}
 */
var stageTecDel = exports.stageTecDel = function stageTecDel(data) {
  return _api.default.request({
    url: '/matchStageExpert/delStageExpert',
    method: 'post',
    data: data
  });
};
/**
 * 描述 根据项目id回显项目信息
 * @author kkdy
 * @date 2021-12-16
 * @param {any} data
 * @returns {any}
 */
var backView = exports.backView = function backView(data) {
  return _api.default.request({
    url: '/match/getMatchById',
    method: 'post',
    data: _qs.default.stringify(data)
  });
};
/**
 * 描述 获取项目下的管理员
 * @author kkdy
 * @date 2022-03-18
 * @param {any} data
 * @returns {any}
 */
var getObjectAdminList = exports.getObjectAdminList = function getObjectAdminList(data) {
  return _api.default.request({
    url: '/match/matchAdminList',
    method: 'post',
    data: data
  });
};
/**
 * 描述 获取省份下的项目管理员
 * @author kkdy
 * @date 2022-03-18
 * @param {any} data
 * @returns {any}
 */
var findObjectAdminList = exports.findObjectAdminList = function findObjectAdminList(data) {
  return _api.default.request({
    url: '/user/getMatchAdmins',
    method: 'post',
    data: data
  });
};
/**
 * 描述 新增省项目管理员
 * @author kkdy
 * @date 2022-03-18
 * @param {any} data
 * @returns {any}
 */
var addAdminList = exports.addAdminList = function addAdminList(data) {
  return _api.default.request({
    url: '/user/saveUser',
    method: 'post',
    data: data
  });
};
/**
 * 描述 新增项目下管理员
 * @author kkdy
 * @date 2022-03-18
 * @param {any} data
 * @returns {any}
 */
var addObjectAdmin = exports.addObjectAdmin = function addObjectAdmin(data) {
  return _api.default.request({
    url: '/user/saveUser',
    method: 'post',
    data: data
  });
};
/**
 * 描述 删除省项目管理员
 * @author kkdy
 * @date 2022-03-18
 * @param {any} data
 * @returns {any}
 */
var delAdmin = exports.delAdmin = function delAdmin(data) {
  return _api.default.request({
    url: '/user/deleteUser',
    method: 'post',
    data: data
  });
};
/**
 * 描述 重置密码
 * @author kkdy
 * @date 2022-03-18
 * @param {any} data
 * @returns {any}
 */
var resetPass = exports.resetPass = function resetPass(data) {
  return _api.default.request({
    url: '/user/resetPass',
    method: 'post',
    data: data
  });
};
/**
 * 描述 为项目分配管理员
 * @author kkdy
 * @date 2022-03-18
 * @param {any} data
 * @returns {any}
 */
var payForAdmin = exports.payForAdmin = function payForAdmin(data) {
  return _api.default.request({
    url: '/match/saveMatchAdmin',
    method: 'post',
    data: data
  });
};
/**
 * 描述 移出项目管理员
 * @author kkdy
 * @date 2022-03-18
 * @param {any} data
 * @returns {any}
 */
var removeAdmin = exports.removeAdmin = function removeAdmin(data) {
  return _api.default.request({
    url: '/match/removeMatchAdmin',
    method: 'post',
    data: data
  });
};
/**
 * 描述 获取学校列表
 * @author kkdy
 * @date 2022-03-21
 * @param {any} data
 * @returns {any}
 */
var getSchoolList = exports.getSchoolList = function getSchoolList(data) {
  return _api.default.request({
    url: '/school/schoolListByCode',
    method: 'post',
    data: data
  });
};
/**
 * 描述 同步所有学校到项目单位中去
 * @author kkdy
 * @date 2022-03-21
 * @param {any} data
 * @returns {any}
 */
var insertAllSchoolAllMatchSchool = exports.insertAllSchoolAllMatchSchool = function insertAllSchoolAllMatchSchool(data) {
  return _api.default.request({
    url: '/matchSchool/insertAllSchoolAllMatchSchool',
    method: 'post',
    data: data
  });
};
/**
 * 描述 导出认定建设表
 * @author kkdy
 * @date 2022-03-21
 * @param {any} data
 * @returns {any}
 */
var exportJiangsuTableSecond = exports.exportJiangsuTableSecond = function exportJiangsuTableSecond(data) {
  return _api.default.request({
    url: '/jiangsuTableSecond/export',
    method: 'post',
    data: data,
    // data: qs.stringify(data),
    responseType: 'blob'
  });
};